export const UNSUBSCRIBED_CONTACT_DELETE_OPEN_MODAL = "UNSUBSCRIBED_CONTACT_DELETE_OPEN_MODAL";
export const UNSUBSCRIBED_CONTACT_DELETE_CLOSE_MODAL = "UNSUBSCRIBED_CONTACT_DELETE_CLOSE_MODAL";

export const UNSUBSCRIBED_CONTACT_DELETE_REQUEST = "UNSUBSCRIBED_CONTACT_DELETE_REQUEST";
export const UNSUBSCRIBED_CONTACT_DELETE_RESULT = "UNSUBSCRIBED_CONTACT_DELETE_RESULT";